<template>
  <div class="filter">
    <BDropdown aria-role="list" :disabled="disabled">
      <button slot="trigger" class="button">
        <span class="text">{{ filter.i18nTitle | t }}</span>
        <span class="count">{{ selectedFiltersCount }}</span>
        <i class="icon-angle-down" aria-hidden="true" />
      </button>
      <component
        :is="isProductsFilter ? 'BRadio' : 'BCheckbox'"
        v-for="value in filter.values"
        :key="value.value"
        v-model="selectedFiltersModel"
        :nativeValue="value.name"
        aria-role="listitem"
        @input="onChange($event)"
      >
        {{ value.i18nKey | t }}
      </component>
      <a
        href="#"
        class="clearLink"
        :class="{ isDisabled: selectedFiltersModel.length === 0 }"
        @click.prevent="clearFilters"
      >
        {{ "dropdown.clear" | t }}
      </a>
    </BDropdown>
  </div>
</template>

<script>
export default {
  name: "DropDown",
  props: {
    filter: {
      type: Object,
      required: true,
    },
    selectedFilters: {
      type: [Array, String],
      default: () => [],
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      selectedFiltersModel: this.selectedFilters,
    };
  },
  computed: {
    selectedFiltersCount() {
      const selected = this.selectedFiltersModel.length;
      if (!this.isProductsFilter) {
        if (selected > 3) return "(+3)";
        if (selected > 0) return `(${selected})`;
      }
      return selected > 0 ? "(1)" : "";
    },
    isProductsFilter() {
      return this.filter.name === "products";
    },
  },
  watch: {
    selectedFilters() {
      this.selectedFiltersModel = this.selectedFilters;
    },
  },
  methods: {
    onChange(newValue) {
      const name = this.filter.name;
      const values = this.filter.values.filter((value) => newValue.includes(value.name));
      this.$emit("filterChange", { name, values });
    },
    clearFilters() {
      // reset for immediate unselecting of all checkboxes on UI.
      // Without it filters will be reset too but with a slight delay
      this.selectedFiltersModel = [];
      this.onChange([]);
    },
  },
};
</script>

<style lang="scss" scoped>
.filter {
  margin: 0 12px 20px 0;
}

.text {
  padding-left: 8px;
}

.count {
  padding: 0 3px;
  color: $primary;
}

.clearLink,
.clearLink:hover {
  display: inline-block;
  margin: 10px 16px;
  color: $primary;
  cursor: pointer;
}

.isDisabled,
.isDisabled:hover {
  color: $gray-400;
  cursor: not-allowed;
}
</style>
